import request from 'tools/request'

export const SET_APPLICATION_OFFERS_LIST = 'SET_APPLICATION_OFFERS_LIST'
export const SET_APPLICATION_OFFER_DETAIL = 'SET_APPLICATION_OFFER_DETAIL'
export const SET_APPLICATION_OFFER_AVAILABLE_SUMMARY = 'SET_APPLICATION_OFFER_AVAILABLE_SUMMARY'
export const SET_APPLICATION_OFFER_SUMMARY = 'SET_APPLICATION_OFFER_SUMMARY'
export const SET_APPLICATION_OFFER_OWNER_SUMMARY = 'SET_APPLICATION_OFFER_OWNER_SUMMARY'

// Action creator to dispatch the application offers list
export const dispatchApplicationOffersList = (applicationOffers, headers) => ({
  type: SET_APPLICATION_OFFERS_LIST,
  payload: {
    applicationOffers,
    totalRecords: parseInt(headers['x-pagination-total-records']) || 0,
    totalPages: parseInt(headers['x-pagination-total-pages']) || 0,
  }
})

// Action creator to dispatch application offer detail
export const dispatchApplicationOfferDetail = (applicationOffer) => ({
  type: SET_APPLICATION_OFFER_DETAIL,
  payload: applicationOffer
})

// Action creator to dispatch available summary
export const dispatchApplicationOfferAvailableSummary = (availableSummary) => ({
  type: SET_APPLICATION_OFFER_AVAILABLE_SUMMARY,
  payload: availableSummary
})

// Action creator to dispatch summary data
export const dispatchApplicationOfferSummary = (summaryData) => ({
  type: SET_APPLICATION_OFFER_SUMMARY,
  payload: summaryData
})

// Action creator to dispatch owner summary data
export const dispatchApplicationOfferOwnerSummary = (ownerSummaryData) => ({
  type: SET_APPLICATION_OFFER_OWNER_SUMMARY,
  payload: ownerSummaryData
})

// Action to get application offers list from the marketplace API
export const getApplicationOffersList = (pagination = {}, filters = {}, demoMode = false) => async (dispatch, getState) => {

  if (pagination?.orderBy?.field) {
    switch (pagination?.orderBy?.field) {
      case 'applicationName':
        pagination.orderBy.field = 'applicationName'
        break;
      case 'ownerName':
        pagination.orderBy.field = 'ownerName'
        break;
      case 'status':
        pagination.orderBy.field = 'status'
        break;
      case 'state':
        pagination.orderBy.field = 'state'
        break;
      case 'businessType':
        pagination.orderBy.field = 'businessType'
        break;
      case 'industryType':
        pagination.orderBy.field = 'industryType'
        break;
      default:
        break;
    }
  }

  const res = await request(
    'marketplace/applications',
    'GET',
    null,
    true,
    {
      'x-pagination-num': pagination.page || 0,
      'x-pagination-limit': pagination.sizePerPage || 20,
      'x-pagination-sort': `${pagination?.orderBy?.field || 'createdAt'},${pagination?.orderBy?.order || 'desc'}`,
      'x-demo-mode': demoMode
    },
    filters
  )
  dispatch(dispatchApplicationOffersList(res.response, res.headers))
  return res
}

// Action to get application offer info by ID
export const getApplicationOfferById = (roxMatchId) => async (dispatch) => {
  const res = await request(
    `marketplace/applications/${roxMatchId}/info`,
    'GET'
  )
  dispatch(dispatchApplicationOfferDetail(res))
  return res
}

// Action to get application offer available summary
export const getApplicationOfferAvailableSummary = (roxMatchId) => async (dispatch) => {
  const res = await request(
    `marketplace/applications/${roxMatchId}/availableSummary`,
    'GET'
  )
  dispatch(dispatchApplicationOfferAvailableSummary(res))
  return res
}

// Action to get application offer summary by report type
export const getApplicationOfferSummary = (roxMatchId, reportType = 'UCC') => async (dispatch) => {
  const res = await request(
    `marketplace/applications/${roxMatchId}/summary`,
    'GET',
    null,
    true,
    {},
    { reportType }
  )
  dispatch(dispatchApplicationOfferSummary(res))
  return res
}

// Action to get application offer owner summary
export const getApplicationOfferOwnerSummary = (roxMatchId, roxAppOwnerId, reportType = 'UCC') => async (dispatch) => {
  const res = await request(
    `marketplace/applications/${roxMatchId}/summary/owners/${roxAppOwnerId}`,
    'GET',
    null,
    true,
    {},
    { reportType }
  )
  dispatch(dispatchApplicationOfferOwnerSummary(res))
  return res
}

// Marketplace version of getSummaryInfo for application offers
export const getApplicationOfferSummaryInfo = (roxMatchId) => async () => {
  try {
    const res = await request(`marketplace/applications/${roxMatchId}/summary/insights`, 'GET')
    return res
  } catch (error) {
    // Return empty data in expected format as fallback
    return { 
      summary: [], 
      additionalSummary: [] 
    }
  }
}

// Marketplace version of requestApplicationInfo for application offers  
export const requestApplicationOfferInfo = (roxMatchId) => async () => {
  const res = await request(`marketplace/applications/${roxMatchId}/info`, 'GET')
  return res
}

// Marketplace version of getSummaryReportByEntity for application offers
export const getApplicationOfferSummaryReportByEntity = (roxMatchId, entityId, type) => async () => {
  if (type === 'LEXIS_BACKGROUND') {
    return await request(`marketplace/applications/${roxMatchId}/backgroundVerification/entity`,
      'GET', null, true, {}, {entityId: entityId})
  }
  if (type === 'FMCSA') {
    return await request('marketplace/applications/' + roxMatchId + '/fmcsa/data', 'GET', null)
  }
  if (type === 'LEXIS_VERIFICATION') {
    return await request(`marketplace/applications/${roxMatchId}/verifications`, 'GET', null)
  }
  if (type === 'UCC') {
    return await request(`marketplace/applications/${roxMatchId}/ucc/entity`,
      'GET', null, true, {}, {entityId: entityId})
  }
  if (type === 'BUSINESS_CREDIT') {
    return await request(`marketplace/applications/${roxMatchId}/businessCredit/entity`,
      'GET', null, true, {}, {entityId: entityId})
  }
  return null
}

// Action to get application offer available summary (curried version for components)
export const getApplicationOfferAvailableSummaryForComponents = (roxMatchId) => async () => {
  const res = await request(
    `marketplace/applications/${roxMatchId}/availableSummary`,
    'GET'
  )
  return res
}

// Marketplace version of getBusinessReportSummary for application offers
export const getApplicationOfferBusinessReportSummary = (roxMatchId, reportType, isDemoMode = false) => async () => {
  const headers = isDemoMode ? { 'x-demo-mode': isDemoMode } : {}
  const res = await request(`marketplace/applications/${roxMatchId}/summary?reportType=${reportType}`, 'GET', null, false, headers)
  return res
}

// Marketplace version of getOwnerReportSummary for application offers
export const getApplicationOfferOwnerReportSummary = (roxMatchId, ownerId, reportType) => async () => {
  const res = await request(`marketplace/applications/${roxMatchId}/summary/owners/${ownerId}?reportType=${reportType}`, 'GET')
  return res
}

// Purchase an application offer
export const purchaseApplicationOffer = (roxMatchId) => async () => {
  const res = await request(`marketplace/applications/${roxMatchId}/purchase`, 'PATCH')
  return res
}

// Decline an application offer
export const declineApplicationOffer = (roxMatchId, reason) => async () => {
  const payload = reason ? { reason } : {}
  const res = await request(`marketplace/applications/${roxMatchId}/decline`, 'PATCH', payload)
  return res
}